<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
      </v-toolbar>
      <v-card-text style="padding: 20px">
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Data e Hora"
                  placeholder="DATA E HORA AQUI dd/mm/YYYY HH:mm"
                  persistent-hint
                  hint="dd/mm/YYYY HH:mm"
                  v-mask="'00/00/0000 00:00'"
                  v-model="data.datehour"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  v-model="data.prefecture_id"
                  label="Prefeitura"
                  :items="prefectures"
                  :rules="fieldRules"
                  item-text="prefecture_social_name"
                  item-value="prefecture_id"
                  @change="
                    [
                      getItems(data.prefecture_id),
                      getVehicles(data.prefecture_id),
                      getProviders(data.prefecture_id),
                    ]
                  "
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  v-model="data.provider_id"
                  label="Participante"
                  :items="providers"
                  :rules="fieldRules"
                  item-text="provider_name"
                  item-value="provider_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Veículo:"
                  :rules="fieldRules"
                  :items="vehicles"
                  item-value="vehicle_id"
                  v-model="data.vehicle_id"
                >
                  <template slot="selection" slot-scope="{ item }"
                    >{{ item.brand_desc }} - {{ item.model_desc }} -
                    {{ item.vehicle_board }}</template
                  >
                  <template slot="item" slot-scope="{ item }"
                    >{{ item.brand_desc }} - {{ item.model_desc }} -
                    {{ item.vehicle_board }}</template
                  >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-autocomplete
                  label="Item:"
                  :rules="fieldRules"
                  :items="items"
                  item-value="item_id"
                  item-text="item_name"
                  v-model="data.item_id"
                >
                  <template slot="selection" slot-scope="{ item }"
                    >{{ item.item_description_desc }} preço R$:
                    {{ realMaskII(item.item_price.toFixed(3)) }}</template
                  >
                  <template slot="item" slot-scope="{ item }"
                    >{{ item.item_description_desc }} preço R$:
                    {{ realMaskII(item.item_price.toFixed(3)) }}</template
                  >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  label="Preço Item"
                  placeholder="Preço do Item"
                  v-model="data.supply_bidding_price"
                  v-mask-decimal.br="2"
                  @blur="calculateTotal"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  label="Litros"
                  v-model="data.supply_liters_stocked"
                  v-mask-decimal.br="2"
                  @input="calculateTotal"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  label="Valor"
                  v-model="data.supply_bidding_value"
                  v-mask-decimal.br="2"
                  @blur="calculatePrice"
                />
              </v-col>
              <v-col cols="12" sm="12" md="3">
                <v-text-field
                  label="Numéro da Nota Fiscal"
                  v-model="data.supply_coupon"
                  v-mask-number
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-footer style="padding: 10px">
        <v-spacer />
        <v-btn
          :disabled="!valid && loader"
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
          >Confirmar</v-btn
        >
      </v-footer>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  props: ["id"],
  mixins: [Helpers],
  data: () => ({
    showPassword: false,
    password: "",
    copiado: false,
    valid: false,
    loader: false,
    showForm: false,
    providers: [],
    drivers: [],
    vehicles: [],
    prefectures: [],
    items: [],
    driver_name: "",
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      supply_id: null,
      datehour: null,
      supply_bidding_price: 0,
      supply_liters_stocked: 0,
      supply_bidding_value: 0,
      supply_coupon: 0,
      item_id: null,
      prefecture_id: null,
      vehicle_id: null,
      provider_id: null,
    },
  }),
  created() {
    this.Helpers;
    this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
    this.loader = false;
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/billings/nfes/${this.id}`).then((r) => {
        this.data = r.data[0];
        this.data.datehour = this.convertDateTime(r.data[0].datehour);
        this.data.supply_liters_stocked = this.data.supply_liters_stocked.toFixed(
          2
        );
        this.data.supply_bidding_value = this.data.supply_bidding_value.toFixed(
          2
        );
        this.data.supply_bidding_price = this.data.supply_bidding_price.toFixed(
          2
        );
        this.getVehicles(r.data[0].prefecture_id);
        this.getItems(r.data[0].prefecture_id);
        this.getProviders(r.data[0].prefecture_id);
        this.$store.dispatch("setLoader", false);
      });
    }
  },
  methods: {
    calculateTotal() {
      if (
        this.data.supply_liters_stocked &&
        this.data.supply_bidding_price &&
        parseFloat(this.data.supply_liters_stocked) > 0 &&
        parseFloat(this.data.supply_bidding_price) > 0
      ) {
        let liters = this.convertDecimalNumberIII(
          this.data.supply_liters_stocked
        );
        let item_price = this.convertDecimalNumberIII(
          this.data.supply_bidding_price
        );
        this.data.supply_bidding_value = (
          parseFloat(liters) * parseFloat(item_price)
        ).toFixed(2);
      }
    },
    calculatePrice() {
      if (
        this.data.supply_bidding_value &&
        this.data.supply_liters_stocked &&
        parseFloat(this.data.supply_bidding_value) > 0 &&
        parseFloat(this.data.supply_liters_stocked) > 0
      ) {
        let liters = this.convertDecimalNumberIII(
          this.data.supply_liters_stocked
        );
        let value = this.convertDecimalNumberIII(
          this.data.supply_bidding_value
        );
        this.data.supply_bidding_price = (
          parseFloat(value) / parseFloat(liters)
        ).toFixed(2);
      }
    },
    getProviders() {
      this.providers = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/readjust/providers/${this.data.prefecture_id}`)
        .then((r) => {
          this.providers = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getVehicles() {
      this.vehicles = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/distribution/vehicles/prefecture/${this.data.prefecture_id}`)
        .then((r) => {
          this.vehicles = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getItems() {
      this.items = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/billings/nfes/items/${this.data.prefecture_id}`)
        .then((r) => {
          this.items = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    loadItems(provider_id) {
      this.$http
        .get(`/supplies/providers/${provider_id}`)
        .then((r) => (this.items = r.data));
    },
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/billings/nfes/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.loader = true;
            setTimeout(() => {
              this.$router.push("/nfe");
            }, 1500);
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/billings/nfes", this.data)
          .then((r) => {
            setTimeout(() => {
              this.$router.push("/nfe");
            }, 1500);
            this.showPassword = true;
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
